import { createStructuredSelector } from "reselect";
import {
    CR_SUPPLIER,
    CR_SUPPLIER_SUCCESS,
    CR_SUPPLIER_ERROR,
    CR_DELIVERY_ORDER,
    CR_DELIVERY_ORDER_SUCCESS,
    CR_DELIVERY_ORDER_ERROR,
    CR_ASSIGNED_USER,
    CR_ASSIGNED_USER_SUCCESS,
    CR_ASSIGNED_USER_ERROR,
    CR_STATUS,
    CR_STATUS_SUCCESS,
    CR_STATUS_ERROR,
    CR_LIST,
    CR_LIST_SUCCESS,
    CR_LIST_ERROR,
    CR_LIST_SEARCH_CHANGE,
    CR_LIST_PAGE_SET,
    CR_ASSIGN_MODAL_SET,
    CR_ASSIGN_CHANGE_SET,
    CR_ASSIGN,
    CR_ASSIGN_SUCCESS,
    CR_ASSIGN_ERROR,
    CR_LIST_UNASSIGNED,
    CR_LIST_UNASSIGNED_SUCCESS,
    CR_LIST_UNASSIGNED_ERROR,
    CR_LIST_USER,
    CR_LIST_USER_SUCCESS,
    CR_LIST_USER_ERROR,
    CR_VERIFY_MODAL_SET,
    CR_VERIFY_CHANGE_SET,
    CR_VERIFY,
    CR_VERIFY_SUCCESS,
    CR_VERIFY_ERROR,
} from "../../actions";

export const NAME = 'cashReceipt';

export const CRSupplier = (data) => ({
    type: CR_SUPPLIER,
    payload: data
});

export const CRSupplierSuccess = (data) => ({
    type: CR_SUPPLIER_SUCCESS,
    payload: data
});

export const CRSupplierError = (error) => ({
    type: CR_SUPPLIER_ERROR,
    payload: error
});

export const CRDeliveryOrder = (data) => ({
    type: CR_DELIVERY_ORDER,
    payload: data
});

export const CRDeliveryOrderSuccess = (data) => ({
    type: CR_DELIVERY_ORDER_SUCCESS,
    payload: data
});

export const CRDeliveryOrderError = (error) => ({
    type: CR_DELIVERY_ORDER_ERROR,
    payload: error
});

export const CRAssignedUser = (data) => ({
    type: CR_ASSIGNED_USER,
    payload: data
});

export const CRAssignedUserSuccess = (data) => ({
    type: CR_ASSIGNED_USER_SUCCESS,
    payload: data
});

export const CRAssignedUserError = (error) => ({
    type: CR_ASSIGNED_USER_ERROR,
    payload: error
});

export const CRStatus = (data) => ({
    type: CR_STATUS,
    payload: data
});

export const CRStatusSuccess = (data) => ({
    type: CR_STATUS_SUCCESS,
    payload: data
});

export const CRStatusError = (error) => ({
    type: CR_STATUS_ERROR,
    payload: error
});

export const CRList = (page, num_page, orderBy, filters, stateFilter) => ({
    type: CR_LIST,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter }
});

export const CRListSuccess = (data) => ({
    type: CR_LIST_SUCCESS,
    payload: data
});

export const CRListError = (error) => ({
    type: CR_LIST_ERROR,
    payload: error
});

export const CRPageSet = (data) => ({
    type: CR_LIST_PAGE_SET,
    payload: data
});

export const CRSearchChange = (data) => ({
    type: CR_LIST_SEARCH_CHANGE,
    payload: data
});

export const CRAssignModalSet = (data) => ({
    type: CR_ASSIGN_MODAL_SET,
    payload: data
});

export const CRAssignChangeSet = (data) => ({
    type: CR_ASSIGN_CHANGE_SET,
    payload: data
});

export const CRAssign = (page, num_page, orderBy, filters, data) => ({
    type: CR_ASSIGN,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, data: data }
});

export const CRAssignSuccess = (message) => ({
    type: CR_ASSIGN_SUCCESS,
    payload: message
});

export const CRAssignError = (error) => ({
    type: CR_ASSIGN_ERROR,
    payload: error
});


export const CRListUnassigned = (data) => ({
    type: CR_LIST_UNASSIGNED,
    payload: data
});

export const CRListUnassignedSuccess = (data) => ({
    type: CR_LIST_UNASSIGNED_SUCCESS,
    payload: data
});

export const CRListUnassignedError = (error) => ({
    type: CR_LIST_UNASSIGNED_ERROR,
    payload: error
});

export const CRListUser = (data) => ({
    type: CR_LIST_USER,
    payload: data
});

export const CRListUserSuccess = (data) => ({
    type: CR_LIST_USER_SUCCESS,
    payload: data
});

export const CRListUserError = (error) => ({
    type: CR_LIST_USER_ERROR,
    payload: error
});

export const CRVerifyModalSet = (data) => ({
    type: CR_VERIFY_MODAL_SET,
    payload: data
});

export const CRVerifyChangeSet = (data) => ({
    type: CR_VERIFY_CHANGE_SET,
    payload: data
});

export const CRVerify = (page, num_page, orderBy, filters, data) => ({
    type: CR_VERIFY,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, data: data }
});

export const CRVerifySuccess = (message) => ({
    type: CR_VERIFY_SUCCESS,
    payload: message
});

export const CRVerifyError = (error) => ({
    type: CR_VERIFY_ERROR,
    payload: error
});

const cashReceipt = (state) => state[NAME];

export const CashReceiptSelector = createStructuredSelector({
    cashReceipt
})